// extracted by mini-css-extract-plugin
export default {"page":"classes@desktop_page__q8SdI","mainMap":"classes@desktop_mainMap__Lyate","mainContent":"classes@desktop_mainContent__qEDd5"};